/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { UpdateUserDoorbellNamePayload } from 'api/actions/update-user-doorbell-name/update-user-doorbell-name-payload';
import { UpdateUserDoorbellNamePathParameters } from 'api/actions/update-user-doorbell-name/update-user-doorbell-name-path-parameters';
import { UpdateUserDoorbellNameResponse } from 'api/actions/update-user-doorbell-name/update-user-doorbell-name-response';

type UpdateUserDoorbellNameQueryParameters = Record<string, any>;

/**
 * The path of the UpdateUserDoorbellName action.
 */
export const updateUserDoorbellNameActionPath = new SweetPath<keyof UpdateUserDoorbellNamePathParameters>(
  '/user/doorbell-name',
  { path: '{param}' }
);

/**
 * Creates a contextualized UpdateUserDoorbellName actions.
 */
export default function createUpdateUserDoorbellNameAction(axios: AxiosInstance) {
  return function updateUserDoorbellNameAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: UpdateUserDoorbellNameQueryParameters;
    payload: UpdateUserDoorbellNamePayload;
  }) {
    const path = updateUserDoorbellNameActionPath.original;

    return axios.put<UpdateUserDoorbellNameResponse, UpdateUserDoorbellNameResponse, UpdateUserDoorbellNamePayload>(
      path,
      payload
    );
  };
}
